import {DefaultWizardHelpers} from "../../../../../../common/components/wizards/DefaultWizardHelpers";
import {ApplicationOptions} from "../../../../../../../../common/model/types/applicationOptions/ApplicationOptions";
import {asString} from "../../../../../../../../common/helpers/converters/asString";

export function getApplicationInputCellHelpers(row: ApplicationOptions, wh: DefaultWizardHelpers) {
    const initialValue = asString(wh.stepData?.[row.type] ?? row.settings ?? '');

    const onChange = async (event: React.ChangeEvent<HTMLElement>, value: string) => {
        const stepData = await wh.stepData$;
        await wh.setStepData({
            ...stepData,
            [row.type]: value,
            ...(row.type === 'application_type' && value !== 'dynamo'
                ? {platform_access: ''}
                : {})
        });
    }

    return {onChange, initialValue};
}